module.exports = __webpack_public_path__ + "static/media/contract_print.f9f353c6.svg";